export type HeadingSizeProps = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';

export const headingSize: {
  [key in HeadingSizeProps]: { fontSize: number; lineHeight: number; fontWeight: number };
} = {
  h1: {
    fontSize: 28,
    lineHeight: 34,
    fontWeight: 700,
  },
  h2: {
    fontSize: 22,
    lineHeight: 28,
    fontWeight: 700,
  },
  h3: {
    fontSize: 20,
    lineHeight: 24,
    fontWeight: 600,
  },
  h4: {
    fontSize: 18,
    lineHeight: 22,
    fontWeight: 600,
  },
  h5: {
    fontSize: 16,
    lineHeight: 20,
    fontWeight: 600,
  },
  h6: {
    fontSize: 14,
    lineHeight: 18,
    fontWeight: 600,
  },
};
